<template>
  <header>
    <nav class="nav">
      <router-link to="/">
        <img src="../assets/logo.png" alt="Logo" class="logo" />
      </router-link>
      <button class="hamburger" @click="toggleNav">
        ☰
      </button>
      <div :class="{'nav-links': true, 'open': isNavOpen}">
        <div>
          <router-link to="/proyect" class="button">Proyect</router-link>
          <router-link to="/app" class="button">App</router-link>
          <router-link to="/proyect/terms-of-service" class="button">Terms of Service</router-link>
        </div>
        <div class="right-links">
          <template v-if="isAuthenticated">
            <router-link to="/profile" class="button">Perfil</router-link>
            <router-link to="/feed" class="button">Muro</router-link>
            <button @click="handleLogout" class="button">Cerrar Sesión</button>
          </template>
          <template v-else>
            <router-link to="/login" class="button">Iniciar Sesión</router-link>
            <router-link to="/register" class="button">Registrarse</router-link>
          </template>
        </div>
      </div>
    </nav>

    <div v-if="authError" class="auth-error">{{ authError }}</div>
  </header>
</template>

<script>
import { useUserStore } from "@/stores/user";

export default {
  name: "AppHeader",
  data() {
    return {
      authError: "",
      isNavOpen: false,
    };
  },
  computed: {
    isAuthenticated() {
      const userStore = useUserStore();
      return userStore.isAuthenticated;
    },
  },
  methods: {
    async handleLogout() {
      try {
        // Intentar logout con la API
        const refreshToken = localStorage.getItem('refreshToken');
        
        if (refreshToken) {
          // Importar dinámicamente para evitar problemas de dependencias circulares
          const { authService } = await import('@/services/apiService');
          try {
            await authService.logout(refreshToken);
          } catch (error) {
            console.error('Error al hacer logout en el servidor:', error);
            // Continuar con logout local incluso si falla el servidor
          }
        }
        
        // Usar el store para logout
        const userStore = useUserStore();
        userStore.logout();
        
        // Redirigir al home en lugar de recargar
        this.$router.push('/');
      } catch (error) {
        console.error('Error durante logout:', error);
        // Forzar logout local
        const userStore = useUserStore();
        userStore.logout();
        this.$router.push('/');
      }
    },
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
    },
  },
};
</script>

<style scoped>
.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(10px);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
}

.logo {
  height: 50px;
}

.hamburger {
  display: none;
  font-size: 2em;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.nav-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.center-links {
  display: flex;
  justify-content: center;
  flex-grow: 1;
}

.right-links {
  display: flex;
  justify-content: flex-end;
}

.button {
  margin-right: 1em;
  padding: 0.5em 1em;
  text-decoration: none;
  color: white;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  background: none;
  border: none;
}

/* Estilo específico para el botón de cerrar sesión */
.button:has-text("Cerrar Sesión"),
button.button {
  background-color: #151515;
  border-radius: 4px;
  transition: background-color 0.3s ease;
}

button.button:hover {
  background-color: #252525;
}

.auth-error {
  color: red;
}

@media (max-width: 1000px) {
  .nav-links {
    display: none;
  }

  .nav-links.open {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 60px; /* Adjust based on your header height */
    right: 0;
    background-color: rgba(0, 0, 0, 0.9);
    width: 100%;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  }

  .center-links,
  .right-links {
    flex-direction: column;
    align-items: flex-start;
  }

  .hamburger {
    display: block;
  }
}
</style>